import {
  useProxyEventsQuery,
  VOTING_PROXY_EVENT_TYPES,
  INFORMATIONAL_PROXY_EVENT_TYPES,
} from "src/store/proxyEvent";

export function useVotingProxyEventCounts() {
  const { data: upcoming } = useProxyEventsQuery({
    tab: "upcoming",
    types: VOTING_PROXY_EVENT_TYPES,
    limit: 1,
  });
  const { data: active } = useProxyEventsQuery({
    tab: "active",
    types: VOTING_PROXY_EVENT_TYPES,
    limit: 1,
  });
  const { data: recentlyCompleted } = useProxyEventsQuery({
    tab: "recently_completed",
    types: VOTING_PROXY_EVENT_TYPES,
    limit: 1,
  });

  return {
    upcoming: upcoming?.count ?? 0,
    active: active?.count ?? 0,
    recentlyCompleted: recentlyCompleted?.count ?? 0,
  };
}

export function useInformationalProxyEventCounts() {
  const { data: upcoming } = useProxyEventsQuery({
    tab: "upcoming",
    types: INFORMATIONAL_PROXY_EVENT_TYPES,
    limit: 1,
  });
  const { data: active } = useProxyEventsQuery({
    tab: "active",
    types: INFORMATIONAL_PROXY_EVENT_TYPES,
    limit: 1,
  });
  const { data: recentlyCompleted } = useProxyEventsQuery({
    tab: "recently_completed",
    types: INFORMATIONAL_PROXY_EVENT_TYPES,
    limit: 1,
  });

  return {
    upcoming: upcoming?.count ?? 0,
    active: active?.count ?? 0,
    recentlyCompleted: recentlyCompleted?.count ?? 0,
  };
}
